import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAppSelector } from '../../../../hooks/redux';
import { getLocationTo } from '../../../../redux/CreateOrderSlice/selector';

type DeliveryPointAccordionProps = {
  setActiveStep: (value: number) => void;
  expanded: string | boolean;
  handleChangeAccordion: (
    panel: string
  ) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
};

const DeliveryPointAccordion = ({
  handleChangeAccordion,
  expanded,
  setActiveStep,
}: DeliveryPointAccordionProps) => {
  const { deliveryPointAdress, deliveryPointCode } =
    useAppSelector(getLocationTo);

  return (
    <>
      <Accordion
        expanded={expanded === 'delivery-info'}
        onChange={handleChangeAccordion('delivery-info')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='delivery-info'
          id='delivery-info'
        >
          <Stack
            flexDirection='row'
            justifyContent='space-between'
            sx={{ width: '100%' }}
          >
            <Typography
              className='create-new-order__finish-title'
              variant='h5'
              component='h5'
            >
              Детали доставки
            </Typography>

            <Button onClick={() => setActiveStep(2)}>Изменить</Button>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <Stack
            className='create-new-order__finish'
            spacing={2}
            flexDirection='column'
            component='ul'
            sx={{ padding: 0, margin: 0, listStyle: 'none' }}
          >
            <li>
              <b>Пункт выдачи: </b>
              <span>{deliveryPointAdress}</span>
            </li>
            <li>
              <b>Код пункта выдачи: </b>
              <span>{deliveryPointCode}</span>
            </li>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default DeliveryPointAccordion;
